import axios from 'axios';

const axiosInstance = axios.create({
  // Do something before request is sent
  baseURL: process.env.REACT_APP_ADMIN_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  responseType: 'json'
});

axiosInstance.interceptors.response.use(
  response => response,
  error => {
    if(typeof error.response == "undefined" || (error.response && error.response.status == 401)) {
      //window.location.assign("/auth/logout");
    }

    return Promise.reject((error.response && error.response.data) || 'Something went wrong')
  }
);

export default axiosInstance;